import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';

export const MinimumOrderAmountNotMetModal = (props: AlertProps) => (
    <Alert
        {...props}
        title="Невозможно применить промокод"
        description="Минимальная сумма заказа не достигнута"
        button={
            <DrawerBottomFixed>
                <DrawerButton onClick={props.onClose}>Закрыть</DrawerButton>
            </DrawerBottomFixed>
        }
    />
);
